import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface TableLayoutState {
  columnOrders: Record<string, string[]>;
  setColumnOrder: (tableKey: string, order: string[]) => void;
  getColumnOrder: (tableKey: string) => string[] | undefined;
}

export const useTableDndColumnStore = create<TableLayoutState>()(
  persist(
    (set, get) => ({
      columnOrders: {},
      setColumnOrder: (tableKey, order) => {
        set((state) => ({
          columnOrders: { ...state.columnOrders, [tableKey]: order }
        }));
      },
      getColumnOrder: (tableKey) => get().columnOrders[tableKey]
    }),
    {
      name: 'dynamic-table-layout'
    }
  )
);
